import { Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { useScopedTranslation } from 'app/hooks/i18n';
import type { UserGroup } from './shared';

export const ExtraGroups = ({ groups }: { groups: UserGroup[] | undefined }) => {
  const { t } = useScopedTranslation();
  if (!groups?.length) return null;

  return (
    <Column gap="spacing.general.x2">
      <Text fontWeight="600" variant="bodyBase">
        {t('extraGroups')}
      </Text>
      {groups.map((group) => (
        <Text key={group.id} variant="bodyBase">
          - {group.name}
        </Text>
      ))}
    </Column>
  );
};
